import React from 'react'
import {
    HeaderLeft,
    HeaderRight,
    NavigationControls,
    FloatingCardHeaderWrapper,
    FloatingCardContent,
    Separator, FloatingCardContainer
} from './FloatingCard.styled'
import { Icon, Typography, TextField, Button, ButtonMenu, Scrollbar, Modal } from '@ann/web-components'

const FloatingCard = ({ isOpen, onClose, selectedText }) => {
    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} width={"800px"}>
            <FloatingCardHeaderWrapper>
                <Modal.Header>
                        <HeaderLeft>
                            <Typography category="subtitle" size="medium" weight="bold">
                                Enhance text
                            </Typography>
                        </HeaderLeft>
                        <HeaderRight>
                            <NavigationControls>
                                <div className="left">
                                    <Icon name="chevronLeft" />
                                </div>
                                <Typography category="body" size="medium" weight="regular" color="body">
                                    1 of 1
                                </Typography>
                                <div className="left">
                                    <Icon name="chevronRight" />
                                </div>
                            </NavigationControls>
                        </HeaderRight>
                </Modal.Header>
            </FloatingCardHeaderWrapper>

            <Modal.Body>
                <FloatingCardContainer>
                    <FloatingCardContent>
                        <Scrollbar>
                            {selectedText && (
                                <Typography category="body" size="medium" weight="regular" color="body">
                                    {selectedText}
                                </Typography>
                            )}
                        </Scrollbar>
                    </FloatingCardContent>
                    <Separator/>
                    <TextField
                        label=""
                        placeholder="Summarize how you'd like to change this text (optional)"
                        size="small"
                    />
                </FloatingCardContainer>
            </Modal.Body>

            <Modal.Actions align="end">
                <ButtonMenu label="Refine" size="medium" type="secondary" menuPosition="top">
                    <ButtonMenu.Menu>
                        <ButtonMenu.Item
                            label="Shorten"
                            value="shorten"
                        >
                            Shorten
                        </ButtonMenu.Item>
                        <ButtonMenu.Item
                            label="Elaborate"
                            value="elaborate"
                        >
                            Elaborate
                        </ButtonMenu.Item>
                        <ButtonMenu.Item
                            label="More formal"
                            value="more_formal"
                        >
                            More formal
                        </ButtonMenu.Item>
                        <ButtonMenu.Item
                            label="Casual"
                            value="casual"
                        >
                            Casual
                        </ButtonMenu.Item>
                        <ButtonMenu.Item
                            label="Bulletize"
                            value="bulletize"
                        >
                            Bulletize
                        </ButtonMenu.Item>
                        <ButtonMenu.Item
                            label="Summarize"
                            value="summarize"
                        >
                            Summarize
                        </ButtonMenu.Item>
                        <ButtonMenu.Item
                            label="Retry"
                            value="retry"
                        >
                            Retry
                        </ButtonMenu.Item>
                    </ButtonMenu.Menu>
                </ButtonMenu>

                <ButtonMenu label="Insert" size="medium" type="primary" menuPosition={"top"}>
                    <ButtonMenu.Menu>
                        <ButtonMenu.Item
                            label="Replace"
                            value="replace"
                        >
                            Replace
                        </ButtonMenu.Item>
                    </ButtonMenu.Menu>
                </ButtonMenu>
            </Modal.Actions>
        </Modal>
    )
}

export default FloatingCard
